import React, { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
    const [notification, setNotification] = useState({
        open: false,
        message: '',
        severity: 'info',
        duration: 4000,
    });

    const show = useCallback((message, severity, duration) => {
        setNotification({ open: true, message, severity, duration });
    }, []);

    const showError = useCallback((message) => show(message, 'error', 6000), [show]);
    const showSuccess = useCallback((message) => show(message, 'success', 4000), [show]);
    const showWarning = useCallback((message) => show(message, 'warning', 5000), [show]);

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') return;
        setNotification(prev => ({ ...prev, open: false }));
    };

    return (
        <NotificationContext.Provider value={{ showError, showSuccess, showWarning }}>
            {children}
            <Snackbar
                open={notification.open}
                autoHideDuration={notification.duration}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <MuiAlert
                    onClose={handleClose}
                    severity={notification.severity}
                    variant="filled"
                    sx={{ width: '100%', fontSize: '1.1rem', py: 1.5, px: 3 }}
                >
                    {notification.message}
                </MuiAlert>
            </Snackbar>
        </NotificationContext.Provider>
    );
}

export function useNotification() {
    const ctx = useContext(NotificationContext);
    if (!ctx) throw new Error('useNotification must be used within NotificationProvider');
    return ctx;
}
